import { DrugScheduleEnum } from "./DrugScheduleEnum ";

export interface IScheduleFilter {
    id: DrugScheduleEnum,
    name: string,
    badgeAlias: string
}

export const schedulesList = [
    { id: DrugScheduleEnum.C2, name: 'Schedule II', badgeAlias: 'CII' },
    { id: DrugScheduleEnum.C3, name: 'Schedule III', badgeAlias: 'CIII' },
    { id: DrugScheduleEnum.C4, name: 'Schedule IV', badgeAlias: 'CIV' },
    { id: DrugScheduleEnum.C5, name: 'Schedule V', badgeAlias: 'CV' },
    { id: DrugScheduleEnum.MISC, name: 'MISC', badgeAlias: 'MISC' },
];

export const schedulesListWithCompound = [
    { id: DrugScheduleEnum.C2, name: 'Schedule II', badgeAlias: 'CII' },
    { id: DrugScheduleEnum.C3, name: 'Schedule III', badgeAlias: 'CIII' },
    { id: DrugScheduleEnum.C4, name: 'Schedule IV', badgeAlias: 'CIV' },
    { id: DrugScheduleEnum.C5, name: 'Schedule V', badgeAlias: 'CV' },
    { id: DrugScheduleEnum.Compound, name: 'Compound', badgeAlias: 'COMP' },
    { id: DrugScheduleEnum.MISC, name: 'MISC', badgeAlias: 'MISC' },
];